import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from 'react-query';
import useAuthStore from './stores/authStore';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import CustomerForm from './pages/CustomerForm';
import CustomerDetail from './pages/CustomerDetail';
import MapView from './pages/MapView';
import CytaApi from './pages/CytaApi';
import Settings from './pages/Settings';
import Chatbot from './pages/Chatbot';
import Agent from './pages/Agent';

// Layout
import Layout from './components/Layout';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
      staleTime: 2 * 60 * 1000, // Data is fresh for 2 minutes
      cacheTime: 10 * 60 * 1000, // Cache for 10 minutes
      refetchOnMount: false, // Don't refetch on every mount - use cached data
      keepPreviousData: true // Keep showing old data while fetching new
    },
    mutations: {
      retry: 0
    }
  }
});

function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff'
            },
            success: {
              iconTheme: {
                primary: '#00a933',
                secondary: '#fff'
              }
            }
          }}
        />
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="customers" element={<Customers />} />
            <Route path="customers/new" element={<CustomerForm />} />
            <Route path="customers/:id" element={<CustomerDetail />} />
            <Route path="customers/:id/edit" element={<CustomerForm />} />
            <Route path="map" element={<MapView />} />
            <Route path="cyta-api" element={<CytaApi />} />
            <Route path="settings" element={<Settings />} />
            <Route path="assistant" element={<Chatbot />} />
            <Route path="agent" element={<Agent />} />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
